<template>
    <!--添加模板-->
    <div class="create">
      <nuxt-child />
    </div>
</template>

<script>
    export default {
        name: "add"
    }
</script>

<style scoped>
.create {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// pages/tpl/add.vue